
// // src/components/Sidebar.tsx
// import React from "react";
// import { NavLink } from "react-router-dom";
// import {
//   BarChart2,
//   ShoppingBag,
//   PlusSquare,
//   ClipboardList,
//   Users,
//   MessageSquare,
//   Settings,
//   LogOut,
// } from "lucide-react";

// interface SidebarProps {
//   isOpen?: boolean;
//   onClose?: () => void;
// }

// const Sidebar: React.FC<SidebarProps> = ({ isOpen = false, onClose }) => {
//   return (
//     <>
//       {/* Backdrop for mobile when sidebar open */}
//       {isOpen && (
//         <div
//           className="sidebar-backdrop d-md-none position-fixed top-0 start-0 w-100 h-100"
//           style={{ background: "rgba(0,0,0,0.45)", zIndex: 1040 }}
//           onClick={onClose}
//         />
//       )}

//       <aside
//         className="sidebar p-3 position-fixed top-0 start-0 vh-100 bg-dark text-white"
//         style={{
//           width: 250,
//           zIndex: 1050,
//           transform: isOpen ? "translateX(0)" : "translateX(-100%)",
//           transition: "transform 280ms ease",
//         }}
//       >
//         <h4 className="mb-4 fw-bold text-uppercase">Gidanbu</h4>

//         <ul className="nav flex-column">
//           <li className="nav-item mb-2">
//             <NavLink
//               to="/"
//               end
//               className={({ isActive }) =>
//                 `nav-link d-flex align-items-center text-white ${
//                   isActive ? "active bg-secondary rounded" : ""
//                 }`
//               }
//               onClick={onClose}
//             >
//               <BarChart2 className="me-2" size={18} />
//               Dashboard
//             </NavLink>
//           </li>

//           <li className="nav-item mb-2">
//             <NavLink to="/products" className={({ isActive }) =>
//                 `nav-link d-flex align-items-center text-white ${isActive ? "active bg-secondary rounded" : ""}`
//               } onClick={onClose}>
//               <ShoppingBag className="me-2" size={18} /> Products
//             </NavLink>
//           </li>

//           <li className="nav-item mb-2">
//             <NavLink to="/add-product" className={({ isActive }) =>
//                 `nav-link d-flex align-items-center text-white ${isActive ? "active bg-secondary rounded" : ""}`
//               } onClick={onClose}>
//               <PlusSquare className="me-2" size={18} /> Add Product
//             </NavLink>
//           </li>

//           <li className="nav-item mb-2">
//             <NavLink to="/orders" className={({ isActive }) =>
//                 `nav-link d-flex align-items-center text-white ${isActive ? "active bg-secondary rounded" : ""}`
//               } onClick={onClose}>
//               <ClipboardList className="me-2" size={18} /> Orders
//             </NavLink>
//           </li>

//           <li className="nav-item mb-2">
//             <NavLink to="/customers" className="nav-link d-flex align-items-center text-white" onClick={onClose}>
//               <Users className="me-2" size={18} /> Customers
//             </NavLink>
//           </li>

//           <li className="nav-item mb-2">
//             <NavLink to="/messages" className="nav-link d-flex align-items-center text-white" onClick={onClose}>
//               <MessageSquare className="me-2" size={18} /> Messages
//             </NavLink>
//           </li>

//           <li className="nav-item mb-2">
//             <NavLink to="/settings" className="nav-link d-flex align-items-center text-white" onClick={onClose}>
//               <Settings className="me-2" size={18} /> Settings
//             </NavLink>
//           </li>

//           <li className="nav-item mb-2 mt-auto">
//             <NavLink to="/logout" className="nav-link d-flex align-items-center text-white" onClick={onClose}>
//               <LogOut className="me-2" size={18} /> Logout
//             </NavLink>
//           </li>
//         </ul>
//       </aside>
//     </>
//   );
// };

// export default Sidebar;




// src/components/Sidebar.tsx

// import React from "react";
// import { NavLink } from "react-router-dom";
// import {
//   BarChart2,
//   ShoppingBag,
//   PlusSquare,
//   ClipboardList,
//   Users,
//   Settings,
//   LogOut,
// } from "lucide-react";

// /* ===========================
//    🔐 Role Type
// =========================== */
// type Role = "super_admin" | "admin" | "sub_admin";

// /* ===========================
//    📦 Sidebar Props
// =========================== */
// interface SidebarProps {
//   isOpen?: boolean;
//   onClose?: () => void;
//   role?: Role;
// }

// const Sidebar: React.FC<SidebarProps> = ({
//   isOpen = false,
//   onClose,
//   role,
// }) => {
//   return (
//     <>
//       {/* ✅ Backdrop for mobile */}
//       {isOpen && (
//         <div
//           className="sidebar-backdrop d-md-none position-fixed top-0 start-0 w-100 h-100"
//           style={{ background: "rgba(0,0,0,0.45)", zIndex: 1040 }}
//           onClick={onClose}
//         />
//       )}

//       {/* ✅ Sidebar */}
//       <aside
//         className="sidebar p-3 position-fixed top-0 start-0 vh-100 bg-dark text-white d-flex flex-column"
//         style={{
//           width: 250,
//           zIndex: 1050,
//           transform: isOpen ? "translateX(0)" : "translateX(-100%)",
//           transition: "transform 280ms ease",
//         }}
//       >
//         <h4 className="mb-4 fw-bold text-uppercase">Gidanbu</h4>

//         <ul className="nav flex-column">

//           {/* ✅ Super Admin Only - Dashboard */}
//           {role === "super_admin" && (
//             <li className="nav-item mb-2">
//               <NavLink
//                 to="/"
//                 end
//                 className={({ isActive }) =>
//                   `nav-link d-flex align-items-center text-white ${
//                     isActive ? "active bg-secondary rounded" : ""
//                   }`
//                 }
//                 onClick={onClose}
//               >
//                 <BarChart2 className="me-2" size={18} />
//                 Dashboard
//               </NavLink>
//             </li>
//           )}

//           {/* ✅ Super Admin + Admin - Products */}
//           {(role === "super_admin" || role === "admin") && (
//             <li className="nav-item mb-2">
//               <NavLink
//                 to="/products"
//                 className={({ isActive }) =>
//                   `nav-link d-flex align-items-center text-white ${
//                     isActive ? "active bg-secondary rounded" : ""
//                   }`
//                 }
//                 onClick={onClose}
//               >
//                 <ShoppingBag className="me-2" size={18} />
//                 Products
//               </NavLink>
//             </li>
//           )}

//           {/* ✅ Super Admin + Admin - Add Product */}
//           {(role === "super_admin" || role === "admin") && (
//             <li className="nav-item mb-2">
//               <NavLink
//                 to="/add-product"
//                 className={({ isActive }) =>
//                   `nav-link d-flex align-items-center text-white ${
//                     isActive ? "active bg-secondary rounded" : ""
//                   }`
//                 }
//                 onClick={onClose}
//               >
//                 <PlusSquare className="me-2" size={18} />
//                 Add Product
//               </NavLink>
//             </li>
//           )}

//           {/* ✅ All Roles - Orders */}
//           {(role === "super_admin" ||
//             role === "admin" ||
//             role === "sub_admin") && (
//             <li className="nav-item mb-2">
//               <NavLink
//                 to="/orders"
//                 className={({ isActive }) =>
//                   `nav-link d-flex align-items-center text-white ${
//                     isActive ? "active bg-secondary rounded" : ""
//                   }`
//                 }
//                 onClick={onClose}
//               >
//                 <ClipboardList className="me-2" size={18} />
//                 Orders
//               </NavLink>
//             </li>
//           )}

//           {/* ✅ Super Admin Only - Customers */}
//           {role === "super_admin" && (
//             <li className="nav-item mb-2">
//               <NavLink
//                 to="/customers"
//                 className={({ isActive }) =>
//                   `nav-link d-flex align-items-center text-white ${
//                     isActive ? "active bg-secondary rounded" : ""
//                   }`
//                 }
//                 onClick={onClose}
//               >
//                 <Users className="me-2" size={18} />
//                 Customers
//               </NavLink>
//             </li>
//           )}

//           {/* ✅ Super Admin Only - Settings */}
//           {role === "super_admin" && (
//             <li className="nav-item mb-2">
//               <NavLink
//                 to="/settings"
//                 className={({ isActive }) =>
//                   `nav-link d-flex align-items-center text-white ${
//                     isActive ? "active bg-secondary rounded" : ""
//                   }`
//                 }
//                 onClick={onClose}
//               >
//                 <Settings className="me-2" size={18} />
//                 Settings
//               </NavLink>
//             </li>
//           )}

//           {/* ✅ Logout - All Roles */}
//           <li className="nav-item mt-auto">
//             <NavLink
//               to="/logout"
//               className={({ isActive }) =>
//                 `nav-link d-flex align-items-center text-white ${
//                   isActive ? "active bg-secondary rounded" : ""
//                 }`
//               }
//               onClick={onClose}
//             >
//               <LogOut className="me-2" size={18} />
//               Logout
//             </NavLink>
//           </li>

//         </ul>
//       </aside>
//     </>
//   );
// };

// export default Sidebar;



import React from "react";
import { NavLink } from "react-router-dom";
import {
  BarChart2,
  ShoppingBag,
  PlusSquare,
  ClipboardList,
  Users,
  Settings,
  LogOut,
} from "lucide-react";

type Role = "super_admin" | "admin" | "sub_admin";

interface SidebarProps {
  isOpen?: boolean;
  onClose?: () => void;
  role: Role; // 🔥 required now
}

const Sidebar: React.FC<SidebarProps> = ({
  isOpen = false,
  onClose,
  role,
}) => {
  const canAccessProducts = ["super_admin", "admin"].includes(role);
  const canAccessOrders = ["super_admin", "admin", "sub_admin"].includes(role);

  return (
    <>
      {isOpen && (
        <div
          className="sidebar-backdrop d-md-none position-fixed top-0 start-0 w-100 h-100"
          style={{ background: "rgba(0,0,0,0.45)", zIndex: 1040 }}
          onClick={onClose}
        />
      )}

      <aside
        className="sidebar p-3 position-fixed top-0 start-0 vh-100 bg-dark text-white d-flex flex-column"
        style={{
          width: 250,
          zIndex: 1050,
          transform: isOpen ? "translateX(0)" : "translateX(-100%)",
          transition: "transform 280ms ease",
        }}
      >
        <h4 className="mb-4 fw-bold text-uppercase">Gidanbu</h4>

        <ul className="nav flex-column">
          
          {/* Super Admin Only */}
          {role === "super_admin" && (
            <li className="nav-item mb-2">
              <NavLink
                to="/"
                end
                className={({ isActive }) =>
                  `nav-link d-flex align-items-center text-white ${
                    isActive ? "active bg-secondary rounded" : ""
                  }`
                }
                onClick={onClose}
              >
                <BarChart2 className="me-2" size={18} />
                Dashboard
              </NavLink>
            </li>
          )}

          {/* Products */}
          {canAccessProducts && (
            <>
              <li className="nav-item mb-2">
                <NavLink
                  to="/products"
                  className={({ isActive }) =>
                    `nav-link d-flex align-items-center text-white ${
                      isActive ? "active bg-secondary rounded" : ""
                    }`
                  }
                  onClick={onClose}
                >
                  <ShoppingBag className="me-2" size={18} />
                  Products
                </NavLink>
              </li>

              <li className="nav-item mb-2">
                <NavLink
                  to="/add-product"
                  className={({ isActive }) =>
                    `nav-link d-flex align-items-center text-white ${
                      isActive ? "active bg-secondary rounded" : ""
                    }`
                  }
                  onClick={onClose}
                >
                  <PlusSquare className="me-2" size={18} />
                  Add Product
                </NavLink>
              </li>
            </>
          )}

          {/* Orders */}
          {canAccessOrders && (
            <li className="nav-item mb-2">
              <NavLink
                to="/orders"
                className={({ isActive }) =>
                  `nav-link d-flex align-items-center text-white ${
                    isActive ? "active bg-secondary rounded" : ""
                  }`
                }
                onClick={onClose}
              >
                <ClipboardList className="me-2" size={18} />
                Orders
              </NavLink>
            </li>
          )}

          {/* Super Admin Only */}
          {role === "super_admin" && (
            <>
              <li className="nav-item mb-2">
                <NavLink
                  to="/customers"
                  className={({ isActive }) =>
                    `nav-link d-flex align-items-center text-white ${
                      isActive ? "active bg-secondary rounded" : ""
                    }`
                  }
                  onClick={onClose}
                >
                  <Users className="me-2" size={18} />
                  Customers
                </NavLink>
              </li>

              <li className="nav-item mb-2">
                <NavLink
                  to="/settings"
                  className={({ isActive }) =>
                    `nav-link d-flex align-items-center text-white ${
                      isActive ? "active bg-secondary rounded" : ""
                    }`
                  }
                  onClick={onClose}
                >
                  <Settings className="me-2" size={18} />
                  Settings
                </NavLink>
              </li>
            </>
          )}

          {/* Logout */}
          <li className="nav-item mt-auto">
            <NavLink
              to="/logout"
              className={({ isActive }) =>
                `nav-link d-flex align-items-center text-white ${
                  isActive ? "active bg-secondary rounded" : ""
                }`
              }
              onClick={onClose}
            >
              <LogOut className="me-2" size={18} />
              Logout
            </NavLink>
          </li>
        </ul>
      </aside>
    </>
  );
};

export default Sidebar;